<script context="module">
  export const EVENTS = {
    clickOverlay: 'clickOverlay',
    clickCloseIcon: 'clickCloseIcon',
  };
</script>

<script lang="ts">
  import { createEventDispatcher, onMount } from 'svelte';
  import { fade, slide } from 'svelte/transition';

  import IconClose from '@/comps-sdk/components/icon/close.svelte';

  /**
   * 是否可见
   */
  export let value = false;

  /**
   * 弹出位置，目前仅支持 center 和 bottom
   */
  export let position = 'center';

  /**
   * 是否展示圆角
   */
  export let round = false;

  /**
   * 点击遮罩时，是否关闭
   */
  export let closeOnClickOverlay = true;

  /**
   * 是否展示关闭按钮
   */
  export let closable = false;

  /**
   * 动画时间，单位秒（和 vant 保持一致）
   */
  export let duration = 0.3;

  /**
   * 渲染到哪个节点上
   */
  export let getContainer: string = '';

  let el: HTMLElement | null = null;

  const dispatch = createEventDispatcher();

  const onClickOverlay = () => {
    if (closeOnClickOverlay) {
      value = false;
    }
    dispatch(EVENTS.clickOverlay);
  };

  const onClickCloseIcon = () => {
    value = false;
    dispatch(EVENTS.clickCloseIcon);
  };

  $: isBottom = position === 'bottom';
  $: isCenter = position === 'center';
  const innerDuration = duration * 1000;

  onMount(() => {
    if (getContainer) {
      const container = document.querySelector(getContainer);
      container?.append(el!);
    }
  });
</script>

<div bind:this={el}>
  {#if value}
    <div class="overlay" role="button" tabindex="0" transition:fade on:click={onClickOverlay} on:keyup={() => {}} />
  {/if}

  {#if value && isCenter}
    <div
      transition:fade={{ duration: innerDuration }}
      role="dialog"
      aria-modal="true"
      class={`popup center ${$$restProps.class || ''}`}
      class:round
    >
      <slot />
      {#if closable}
        <div class="icon top-right">
          <IconClose on:click={onClickCloseIcon} />
        </div>
      {/if}
    </div>
  {:else if value && isBottom}
    <div
      transition:slide={{
        duration: innerDuration,
      }}
      role="dialog"
      aria-modal="true"
      class:round
      class={`popup bottom ${$$restProps.class || ''}`}
    >
      <slot />
      {#if closable}
        <div class="icon top-right">
          <IconClose on:click={onClickCloseIcon} />
        </div>
      {/if}
    </div>
  {/if}
</div>

<style lang="scss">
  // 弹窗叠弹窗如果出现不符合预期的覆盖，应是插入dom的层级有问题，理论上叠加的弹窗应在前一个弹窗的后面，才能保证正确的覆盖关系
  $zindex-popup-base: 1000;
  .overlay {
    position: fixed;
    z-index: $zindex-popup-base;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
  }

  .popup {
    position: fixed;
    z-index: $zindex-popup-base;
    max-height: 100%;
    overflow-y: auto;
    background-color: #fff;
    -webkit-overflow-scrolling: touch;

    &.bottom {
      bottom: 0;
      left: 0;
      width: 100%;
      &.round {
        border-radius: 16px 16px 0 0;
      }
    }

    &.center {
      top: 50%;
      left: 50%;
      transform: translate3d(-50%, -50%, 0);
      &.round {
        border-radius: 16px;
      }
    }

    .icon {
      width: 20px;
      height: 20px;
      position: absolute;
      cursor: pointer;
      color: #c8c9cc;
      &.top-right {
        top: 16px;
        right: 16px;
      }
    }
  }
</style>
